type Props = {
  svgProps?: React.SVGProps<SVGSVGElement>
  iconColor?: string
}

export const PeopleIcon = ({ iconColor, svgProps }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      {...svgProps}
    >
      <path
        d="M8.02083 3.52083C8.02077 4.08589 7.88895 4.64314 7.63583 5.14833C7.6078 5.20306 7.59779 5.26525 7.60721 5.32601C7.61664 5.38678 7.64504 5.44301 7.68833 5.48667C8.20168 6.00107 8.89827 6.29061 9.625 6.29167C10.3599 6.29167 11.0646 5.99974 11.5843 5.48011C12.1039 4.96048 12.3958 4.2557 12.3958 3.52083C12.3958 2.78596 12.1039 2.08119 11.5843 1.56156C11.0646 1.04193 10.3599 0.75 9.625 0.75C8.89827 0.751052 8.20168 1.0406 7.68833 1.555C7.64504 1.59866 7.61664 1.65489 7.60721 1.71565C7.59779 1.77642 7.6078 1.8386 7.63583 1.89333C7.88895 2.39853 8.02077 2.95578 8.02083 3.52083Z"
        fill={iconColor || '#131313'}
      />
      <path
        d="M9.625 6.58333C9.15299 6.58388 8.68417 6.6607 8.23667 6.81083C8.19066 6.82775 8.14955 6.85577 8.11698 6.89241C8.08441 6.92904 8.06141 6.97316 8.05 7.02083C8.03874 7.06923 8.03978 7.11968 8.05302 7.16757C8.06627 7.21546 8.0913 7.25927 8.12583 7.295C9.0881 8.27129 9.62675 9.58753 9.625 10.9583C9.62649 11.0352 9.6577 11.1085 9.71208 11.1629C9.76646 11.2173 9.83978 11.2485 9.91667 11.25H13.7083C13.7857 11.25 13.8599 11.2193 13.9146 11.1646C13.9693 11.1099 14 11.0357 14 10.9583C14 9.79801 13.5391 8.68521 12.7186 7.86474C11.8981 7.04427 10.7853 6.58333 9.625 6.58333Z"
        fill={iconColor || '#131313'}
      />
      <path
        d="M1.60417 3.52083C1.60417 4.2557 1.89609 4.96048 2.41572 5.48011C2.93536 5.99974 3.64013 6.29167 4.375 6.29167C5.10987 6.29167 5.81464 5.99974 6.33427 5.48011C6.85391 4.96048 7.14583 4.2557 7.14583 3.52083C7.14583 2.78596 6.85391 2.08119 6.33427 1.56156C5.81464 1.04193 5.10987 0.75 4.375 0.75C3.64013 0.75 2.93536 1.04193 2.41572 1.56156C1.89609 2.08119 1.60417 2.78596 1.60417 3.52083Z"
        fill={iconColor || '#131313'}
      />
      <path
        d="M8.75 10.9583C8.75 9.79801 8.28906 8.68521 7.46859 7.86474C6.64812 7.04427 5.53532 6.58333 4.375 6.58333C3.21468 6.58333 2.10188 7.04427 1.28141 7.86474C0.460936 8.68521 0 9.79801 0 10.9583C0 11.0357 0.0307291 11.1099 0.0854272 11.1646C0.140125 11.2193 0.214312 11.25 0.291667 11.25H8.45833C8.53569 11.25 8.60987 11.2193 8.66457 11.1646C8.71927 11.1099 8.75 11.0357 8.75 10.9583Z"
        fill={iconColor || '#131313'}
      />
    </svg>
  )
}
